import { Box, ChevronDownIcon, Text } from '@radix-ui/themes';
import { Command } from 'cmdk';
import styled from 'styled-components';

const BADGE_ICON_SIZE_SETTINGS_1_AND_2 = {
  name: 'x-badge-size-1-&-2',
  height: 12,
  width: 12,
};

export const BADGE_ICON_SIZE_SETTINGS = {
  1: BADGE_ICON_SIZE_SETTINGS_1_AND_2,
  2: BADGE_ICON_SIZE_SETTINGS_1_AND_2,
  3: {
    name: 'x-badge-size-3',
    height: 16,
    width: 16,
  },
};

const PLUS_ICON_SIZE_SETTINGS_1_AND_2 = {
  name: 'plus-badge-size-1-&-2',
  height: 12,
  width: 12,
};

export const PLUS_ICON_SIZE_SETTINGS = {
  1: PLUS_ICON_SIZE_SETTINGS_1_AND_2,
  2: PLUS_ICON_SIZE_SETTINGS_1_AND_2,
  3: {
    name: 'plus-badge-size-3',
    height: 16,
    width: 16,
  },
};

export const StyledTooltipBox = styled(Box)`
  z-index: ${props => props.theme.zIndex.dialog + 2};
`;

export const StyledCommand = styled(Command)`
  &:focus-visible {
    outline: none;
  }
`;

export const CommandInput = styled(Command.Input)`
  width: calc(100% - 8px);
  height: var(--space-6);
  border-radius: var(--radius-2);
  border: 1px solid var(--neutral-a7);
  outline-color: var(--accent-8);
  text-indent: 8px;
`;

export const StyledPlaceholder = styled(Text)`
  color: var(--neutral-a11);
`;

interface StyledChevronDownIconProps {
  color?: string;
}

export const StyledChevronDownIcon = styled(ChevronDownIcon)<StyledChevronDownIconProps>`
  ${props => props.color && `color: ${props.color};`}
  flex: none;
`;

export const CommandList = styled(Command.List)`
  max-height: 200px;
  overflow-y: auto;
`;

export const StyledCategoryBox = styled(Box)`
  position: sticky;
  top: 0;
  background-color: var(--color-panel-solid);

  &:has(+ [data-ono-category]),
  &:last-child {
    display: none;
  }
`;

export const CommandItem = styled(Command.Item)`
  border-radius: var(--radius-2);
  cursor: pointer;

  &[data-ono-selected='true'] {
    background-color: var(--neutral-a4);
  }

  &[data-selected='true'] {
    background-color: var(--neutral-a3);
  }

  &:is([data-ono-selected='true'], [data-selected='true']) + :is([data-ono-selected='true'], [data-selected='true']) {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }

  &:is([data-ono-selected='true'], [data-selected='true']):has(
      + :is([data-ono-selected='true'], [data-selected='true'])
    ) {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
`;

export const StyledTextBlack = styled(Text)`
  color: var(--neutral-12);
`;

export const StyledTextSingle = styled(Text)`
  max-width: 100%;
  color: ${props => (props.highContrast ? 'var(--neutral-12)' : 'var(--neutral-11a)')};
`;

export const StyledTextMultiple = styled(StyledTextBlack)`
  max-width: 80px;
`;
